import { featureArticles, featuredCategories } from "@/mocks/homeContent";
import { MetaItem, SectionHead } from "./Common";

export default function Featured({
  active,
  onSelect,
}: {
  active: string;
  onSelect: (c: string) => void;
}) {
  const list = active === "全部" ? featureArticles : featureArticles.filter((a) => a.category === active);

  return (
    <section id="featured" className="bg-background-100 py-14 md:py-20 scroll-mt-16 md:scroll-mt-20">
      <div className="container-page">
        <SectionHead
          eyebrow="Deep dive · 深扒精选"
          title="每日黑料深扒 · 全汇总"
          desc="精选当周值得看的深扒内容，从事件源头到关键证据不断补齐，点击分类标签即可筛选你感兴趣的栏目。"
          center
        />

        {/* filter tabs */}
        <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
          {featuredCategories.map((c) => {
            const sel = active === c;
            return (
              <button
                key={c}
                onClick={() => onSelect(c)}
                className={
                  "whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors " +
                  (sel
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-50 text-foreground-700 ring-1 ring-background-300/70 hover:bg-background-200/70")
                }
              >
                {c}
              </button>
            );
          })}
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((a) => (
            <article
              key={a.id}
              className="group flex flex-col overflow-hidden rounded-lg bg-background-50 ring-1 ring-background-300/50 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="relative h-44 overflow-hidden md:h-52">
                <img
                  src={a.image}
                  alt={a.title + " - 每日黑料深扒精选配图"}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-background-950/70 px-2.5 py-1 text-xs font-medium text-background-50 backdrop-blur-sm">
                  {a.category}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <h3 className="font-heading text-[15px] font-bold leading-snug text-foreground-950 md:text-lg">{a.title}</h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{a.summary}</p>
                <div className="mt-3 flex flex-wrap items-center gap-1.5">
                  {a.keywords.map((k) => (
                    <span key={k} className="text-xs text-secondary-700">
                      #{k}
                    </span>
                  ))}
                </div>
                <div className="mt-4 flex items-center gap-5 border-t border-background-200 pt-3 text-foreground-500">
                  <MetaItem icon="ri-calendar-line">{a.date}</MetaItem>
                  <MetaItem icon="ri-eye-line">{a.read}</MetaItem>
                </div>
              </div>
            </article>
          ))}
        </div>

        {list.length === 0 && (
          <p className="mt-10 text-center text-sm text-foreground-500">该栏目内容正在持续产出中，先看看「全部」吧。</p>
        )}
      </div>
    </section>
  );
}